import React from 'react'

const LogoWithText = props => (
  <svg width={238} height={58} {...props}>
    <title>{'Group 5'}</title>
    <defs>
      <path id="prefix__b" d="M5.713 8.77h28.008v9.48H5.713z" />
      <filter
        x="-46.4%"
        y="-116%"
        width="192.8%"
        height="374.3%"
        filterUnits="objectBoundingBox"
        id="prefix__a"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation={4}
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="#0B35CA" d="M26.394 0L.658 26.094l51.94.088z" />
      <g fill="#0B35CA">
        <path d="M7.134 19.39L.431 26.093l6.703 6.704 6.703-6.704zM26.524 0l-6.703 6.703 6.703 6.703 6.703-6.703z" />
      </g>
      <path
        fill="#0B35CA"
        d="M39.403 12.927l6.703 6.703-6.703 6.703-6.704-6.703z"
      />
      <path
        fill="#0B35CA"
        d="M32.94 6.463l6.702 6.704-6.703 6.703-6.703-6.703z"
      />
      <path fill="#0B35CA" d="M26.476 0l6.703 6.703-6.703 6.703-6.703-6.703z" />
      <path
        fill="#8B94EE"
        d="M20.06 6.463l6.704 6.704-6.703 6.703-6.703-6.703z"
      />
      <path fill="#D7E6FF" d="M27.848 16.627l9.75 9.75-9.75 9.75-9.75-9.75z" />
      <g>
        <path
          fill="#8B94EE"
          d="M13.597 26.333L6.894 19.63l6.703-6.703 6.704 6.703z"
        />
        <path
          fill="#0B35CA"
          d="M26.524 52.138l-6.703-6.703 6.703-6.703 6.703 6.703z"
        />
      </g>
      <g>
        <g transform="scale(1 -1) rotate(45 89.741 3.08)">
          <use fill="#000" filter="url(#prefix__a)" xlinkHref="#prefix__b" />
          <use fill="#8B94EE" xlinkHref="#prefix__b" />
        </g>
        <path
          fill="#D7E6FF"
          d="M45.866 32.748l6.703-6.703-6.703-6.703-6.703 6.703z"
        />
        <path
          fill="#0B35CA"
          d="M39.403 26.285l6.703-6.704-6.703-6.703-6.704 6.703z"
        />
      </g>
      <path
        fill="#8B94EE"
        d="M6.83 19.516L.125 26.22 26.33 52.423l6.704-6.703z"
      />
      <path
        d="M87.688 38l-2.08-4.832h-9.376L74.152 38H68.84l9.664-22.368h4.832L93 38h-5.312zm-6.752-15.712l-2.816 6.496h5.6l-2.784-6.496zm24.96 7.776v-9.28h4.832V38h-4.832v-2.272c-1.195 1.685-2.736 2.528-4.624 2.528-1.888 0-3.472-.592-4.752-1.776-1.28-1.184-1.92-2.939-1.92-5.264V20.784h4.832v9.376c0 2.645.97 3.968 2.912 3.968.96 0 1.792-.347 2.496-1.04.704-.693 1.056-1.701 1.056-3.024zM121 24.24v7.712c0 .661.17 1.179.512 1.552.341.373.747.56 1.216.56.896 0 1.653-.405 2.272-1.216l1.792 3.36c-1.493 1.365-3.067 2.048-4.72 2.048-1.653 0-3.05-.544-4.192-1.632-1.141-1.088-1.712-2.57-1.712-4.448V24.24h-2.016v-3.456h2.016v-5.152H121v5.152h4.16v3.456H121zm12 5.152c0 1.408.4 2.555 1.2 3.44.8.885 1.824 1.328 3.072 1.328s2.272-.443 3.072-1.328c.8-.885 1.2-2.032 1.2-3.44s-.4-2.56-1.2-3.456c-.8-.896-1.824-1.344-3.072-1.344s-2.272.448-3.072 1.344c-.8.896-1.2 2.048-1.2 3.456zm13.376 0c0 2.496-.864 4.597-2.592 6.304-1.728 1.707-3.899 2.56-6.512 2.56-2.613 0-4.784-.853-6.512-2.56-1.728-1.707-2.592-3.808-2.592-6.304 0-2.496.864-4.603 2.592-6.32 1.728-1.717 3.899-2.576 6.512-2.576 2.613 0 4.784.859 6.512 2.576 1.728 1.717 2.592 3.824 2.592 6.32zm18.56-2.784h5.024v7.936c-2.219 2.475-5.29 3.712-9.216 3.712-3.285 0-6.043-1.088-8.272-3.264-2.23-2.176-3.344-4.923-3.344-8.24s1.136-6.085 3.408-8.304c2.272-2.219 5.013-3.328 8.224-3.328 3.21 0 6 1.056 8.368 3.168l-2.592 3.744c-1.003-.875-1.925-1.477-2.768-1.808a7.424 7.424 0 0 0-2.736-.496c-1.899 0-3.499.645-4.8 1.936-1.301 1.29-1.952 2.992-1.952 5.104s.624 3.803 1.872 5.072c1.248 1.27 2.736 1.904 4.464 1.904 1.728 0 3.168-.33 4.32-.992v-6.144zm18.048-1.6c-1.43 0-2.496.507-3.2 1.52-.704 1.013-1.056 2.352-1.056 4.016V38h-4.8V20.784h4.8v2.272c.619-.704 1.392-1.301 2.32-1.792.928-.49 1.872-.747 2.832-.768l.032 4.512h-.928zM201.544 38h-4.512v-2.08c-1.237 1.557-2.768 2.336-4.592 2.336-1.824 0-3.355-.528-4.592-1.584-1.237-1.056-1.856-2.464-1.856-4.224 0-1.76.64-3.077 1.92-3.952 1.28-.875 3.03-1.312 5.248-1.312h3.584v-.096c0-1.835-.97-2.752-2.912-2.752-.832 0-1.712.165-2.64.496-.928.33-1.712.741-2.352 1.232l-2.144-3.104c2.261-1.643 4.843-2.464 7.744-2.464 2.09 0 3.797.523 5.12 1.568s1.984 2.699 1.984 4.96V38zm-4.832-6.56v-.832h-3.008c-1.92 0-2.88.597-2.88 1.792 0 .619.23 1.093.688 1.424.459.33 1.115.496 1.968.496s1.605-.261 2.256-.784c.65-.523.976-1.221.976-2.096zm16.096 6.816c-2.027 0-3.84-.864-5.44-2.592-1.6-1.728-2.4-3.872-2.4-6.432 0-2.56.779-4.656 2.336-6.288 1.557-1.632 3.381-2.448 5.472-2.448 2.09 0 3.797.736 5.12 2.208v-8.448h4.8V38h-4.8v-2.272c-1.344 1.685-3.04 2.528-5.088 2.528zm-3.008-8.832c0 1.387.416 2.523 1.248 3.408.832.885 1.803 1.328 2.912 1.328 1.11 0 2.053-.443 2.832-1.328.779-.885 1.168-2.027 1.168-3.424 0-1.397-.39-2.56-1.168-3.488-.779-.928-1.733-1.392-2.864-1.392-1.13 0-2.101.47-2.912 1.408-.81.939-1.216 2.101-1.216 3.488zm26.496-4.416c-1.43 0-2.496.507-3.2 1.52-.704 1.013-1.056 2.352-1.056 4.016V38h-4.8V20.784h4.8v2.272c.619-.704 1.392-1.301 2.32-1.792.928-.49 1.872-.747 2.832-.768l.032 4.512h-.928z"
        fill="#0B35CA"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default LogoWithText